import { createContext, useContext } from 'react'
import { emptyRequestCounts } from 'service/RequestCountsService'

export const RequestCountsContext = createContext(emptyRequestCounts())
export const useRequestCounts = () => useContext(RequestCountsContext)
